import { render, staticRenderFns } from "./CorrespondenciaView.vue?vue&type=template&id=778b4d3e&"
import script from "./CorrespondenciaView.vue?vue&type=script&lang=js&"
export * from "./CorrespondenciaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports